const CONFIG = {
    backendUrl: 'https://prodapi.str8bat.com',
    sessionStorageKey: 'user_details',
    cacheTimeout: 3600000, // 1 hour in milliseconds
};

function initializeCoins(userDetails) {
    try {

        const totalCoinsDisplay = document.querySelector('.total-coins');
        const headerCoins = document.querySelector('.header-coins');
        console.log(totalCoinsDisplay, headerCoins, 'data of init');
        totalCoins = userDetails.coins;
        if (totalCoinsDisplay) {
            totalCoinsDisplay.textContent = totalCoins.toLocaleString();
            headerCoins.textContent = totalCoins.toLocaleString();
        }
        console.log(totalCoins, 'total coins');
    } catch (error) {
        console.error('Error fetching coins:', error);
    }
    }

(async function(){

    let token = null;
    const urlParams = new URLSearchParams(document.location.search);
    const urlToken = urlParams.get('token');

    const jsonUserDetails = sessionStorage.getItem('user_details');
    const userDetails = JSON.parse(jsonUserDetails);

    if(!urlToken){
        if(userDetails.authToken){
            token = userDetails.authToken;
        }
    } else {
        token = urlToken;
    }

    if(!token)return;
    /*if(token){
        sessionStorage.setItem(
            CONFIG.sessionStorageKey,
            JSON.stringify({
                ...userDetails,
                authToken: token,
                timeStamp: Date.now()
            })
        )*/

    try{
        const response = await fetch(
            `${CONFIG.backendUrl}/v3/me/coins`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const { data } = await response.json();
        console.log(data, 'coins from API call');

            sessionStorage.setItem(
                CONFIG.sessionStorageKey,
                JSON.stringify({
                    ...userDetails,
                    ...data,
                    authToken: token,
                    timeStamp: Date.now()
                })
            )
            
            initializeCoins(data);

             }catch(err){
                console.log(err, 'user details err');
             }
    //}

})();